import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Split-screen panes: the slot (and the "land already live" hint) must survive
// this entry's own redirect, or the pane silently falls back to the shared
// session keys. Only these two params are carried, and only as given.
const carryPaneParams = (target) => {
    const p = new URLSearchParams(window.location.search);
    const keep = new URLSearchParams();
    ['demo_slot', 'live'].forEach((key) => {
        const v = p.get(key);
        if (v && /^[\w-]{1,24}$/.test(v)) keep.set(key, v);
    });
    const qs = keep.toString();
    if (!qs) return target;
    return target.includes('?') ? `${target}&${qs}` : `${target}?${qs}`;
};


// Automotive BUYER entry — PUBLIC, no auth. Ensures the demo dealership exists,
// then lands directly on the primary demo vehicle's public showroom. Mirrors the
// property demo entry pattern: immediate dark theme (no white flash), return_url
// handling for a deterministic Back, and graceful degradation on failure (never
// ejects to a marketing/login page).
export default function DemoAutoBuyerEntry() {
    const { t } = useTranslation();
    useEffect(() => {
        const API = (typeof window !== 'undefined' ? window.location.origin : '');
        // Force dark/night immediately so there is no white flash on a projector.
        try { localStorage.setItem('yulontap-theme-preference', 'dark'); } catch (_e) { /* ignore */ }
        document.documentElement.classList.add('dark');
        sessionStorage.setItem('yulontap_auto_demo', '1');
        sessionStorage.removeItem('yulontap_hotel_demo');
        const params = new URLSearchParams(window.location.search);
        const rawReturn = params.get('return_url') || '';
        const returnUrl = rawReturn.startsWith('/') && !rawReturn.startsWith('//') ? rawReturn : '';
        if (returnUrl) sessionStorage.setItem('yulontap_demo_return', returnUrl);
        else sessionStorage.removeItem('yulontap_demo_return');
        (async () => {
            try {
                const res = await fetch(`${API}/api/demo-auto/buyer/info`);
                const d = await res.json();
                const card = d.card_id || 'AUTODEMO-0001';
                const c = params.get('c');
                const suffix = c ? `?c=${encodeURIComponent(c)}` : '';
                window.location.replace(carryPaneParams(`/vehicle/${card}${suffix}`));
            } catch (_e) {
                // Graceful degradation: fall back to the primary demo card rather
                // than ejecting the prospect to the marketing/login page.
                window.location.replace('/vehicle/AUTODEMO-0001');
            }
        })();
    }, []);
    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-neutral-950 text-neutral-200"
            data-testid="demo-auto-buyer-entry">
            <Loader2 className="w-8 h-8 animate-spin text-amber-400" />
            <p className="text-sm">{t('demoAuto.enteringBuyer', 'Opening the showroom…')}</p>
        </div>
    );
}
